import useUser from '../../../../utility/hooks/useUser';
import PropTypes from 'prop-types';

const permissions = {
    hide: 0,
    view: 1,
    edit: 2,
};

const PermissionCheck = ({permissionModule, render, returnType = 'readonly', studentProfile = null}) => {
    const {user} = useUser();

    const hasPermission = () => {
        if (permissionModule === '*') {
            return permissions.edit;
        }

        const isParentOfStudent = studentProfile && studentProfile.isParentOfStudent;

        if (user.permissions.includes(`Permission.${permissionModule}.Edit`)) {
            return permissions.edit;
        }

        if (isParentOfStudent && user.parentPermissions && user.parentPermissions.includes(`Permission.${permissionModule}.Edit`)) {
            return permissions.edit;
        }

        if (user.permissions.includes(`Permission.${permissionModule}.View`)) {
            return permissions.view;
        }

        if (isParentOfStudent && user.parentPermissions && user.parentPermissions.includes(`Permission.${permissionModule}.View`)) {
            return permissions.view;
        }

        return permissions.hide;
    };

    if (returnType === 'readonly') {
        return {
            [permissions.view]: () => render(true),
            [permissions.edit]: () => render(false),
            [permissions.hide]: () => null
        }[hasPermission()]();
    } else if (returnType === 'isEdit') {
        return hasPermission() === permissions.edit ? render(true) : render(false);
    } else {
        return null;
    }

};

PermissionCheck.propTypes = {
    permissionModule: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired,
    returnType: PropTypes.oneOf(['readonly', 'isEdit']),
    studentProfile: PropTypes.shape({
        isParentOfStudent: PropTypes.bool
    })
};

export default PermissionCheck;